import { RootState } from 'store';

export const selectIsSignIn = (state: RootState) => state.auth.isSignedIn;
export const selectCurrentUser = (state: RootState) => state.auth.currentUser;
